module.exports = __webpack_public_path__ + "static/wifi-4e566d0ac6c58f849e67077c3a2e566d.svg";